import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import './livescore.scss';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Simplebutton } from './../form-elements';
import {teamShortHandName} from './../../utils/dataParser';
import {timerData} from './../../constants/common'


const LiveScoreCard = ({livescoreData,currentTimerTime}) => {
    return (
            <div className="live-score-card-container">
                <div className="top-bar">
                    <div className="title">
                    <FormattedMessage id='live_scores' defaultMessage='Live scores'/>
                    </div>
                    <div className="time">
                    { livescoreData.statusShort==='NS'? '00:00':timerData.currentTimeTimer}
                    </div>
                </div>
                <div className="box">
                    <div className="scores">
                        <div className="flag">
                        <img className="homeTeamFlag" src={livescoreData.homeTeam.logo}/>
                        {teamShortHandName(livescoreData.homeTeam.team_name)}
                        </div>
                        <div className="score win">
                            {livescoreData.statusShort==='NS' ? "0" : livescoreData.goalsHomeTeam}
                        </div>
                        <div className="divider"></div>
                        <div className="score win">
                            {livescoreData.statusShort==='NS' ? "0" : livescoreData.goalsAwayTeam}
                        </div>
                        <div className="flag">
                            {teamShortHandName(livescoreData.awayTeam.team_name)}
                            <img className="awayTeamFlag" src={livescoreData.awayTeam.logo}/>
                        </div>
                    </div>
                    {/* <div class="live goal">
                        <p>{""}</p>
                    </div> */}
                </div>
            </div>
    )
}

export default LiveScoreCard;